import { render } from "./Proyectos.vue?vue&type=template&id=3ee8133a&scoped=true"
import script from "./Proyectos.vue?vue&type=script&lang=js"
export * from "./Proyectos.vue?vue&type=script&lang=js"

import "./Proyectos.vue?vue&type=style&index=0&id=3ee8133a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee8133a"]])

export default __exports__